import { ProductOption, ProductVariant } from 'types/product'
import { FilterOption } from 'types/filters'
import { FINISHED_TO_ORDER } from '@consts/index'
import { getSortedProductOptionTypes } from './getSortedProductOptionTypes'

type GetFilteredVariantsArgs = {
  productOptions: ProductOption[]
  variant: ProductVariant
  filterOptions: FilterOption[]
}

export function isMatchingVariantForOptions({
  productOptions,
  variant,
  filterOptions
}: GetFilteredVariantsArgs) {
  const productOptionTypes = getSortedProductOptionTypes(productOptions)

  // Create a mapping of variant options for easier access
  const variantOptions: Record<string, string> =
    variant.options?.reduce(
      (obj, { type, value }) => Object.assign(obj, { [type]: value }),
      {}
    ) || {}
  const options = Object.keys(variantOptions)

  if (!options.length) return false

  return productOptionTypes.every(optionKey => {
    const optionValue = variantOptions[optionKey]
    const selectedValues = filterOptions
      .filter(filter => filter.type === optionKey)
      .map(filter => filter.value)

    if (!selectedValues.length) return true
    // Some configurable product options (for example taper/shorts leg) are
    // represented outside Shopify's variant option payload.
    if (!optionValue) return true
    if (optionValue === FINISHED_TO_ORDER) return true

    return selectedValues.includes(optionValue)
  })
}
